import script from "./CustomInstructions.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomInstructions.vue?vue&type=script&setup=true&lang=js"

import "./CustomInstructions.vue?vue&type=style&index=0&id=0e208daf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e208daf"]])

export default __exports__